<div class="alert-box">
    <div class="modal-header">
        <button type="button" class="close" (click)="onCancel()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">
            {{ "up_tariff_title" | translate }}
        </h4>
    </div>
    <div class="modal-body">
        <div class="alert alert-paid margin-0">
            {{ "paid_elements_text1" | translate }}
            <ul class="paid-elements-list">
                <li *ngFor="let name of widgetNames">
                    {{ name | translate }}
                </li>
            </ul>
            <span
                >{{ "paid_elements_text2" | translate }} <strong>{{ "paid_elements_text3" | translate }}</strong></span
            >
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="onCancel()">
            {{ "cancel" | translate }}
        </button>

        <a href="/landing-pages/plans/" target="_blank" class="btn btn-paid" (click)="onConfirm()">
            {{ "up_tariff" | translate }}
        </a>
    </div>
</div>
